import { ChevronDown, ChevronRight } from '@/assets/icons'
import { IconButton } from '@/components/icon-button/IconButton'
import { kTooltipHoverDelayMs } from '@/constants/constants-ui'

export type EmailAttachmentDisclosureProps = {
  filename: string
  expanded: boolean
  onToggle: () => void
  className?: string
  /** When false, omit the hover tooltip (e.g. row already shows a disabled-state tooltip). Default true. */
  showHoverTooltip?: boolean
}

/**
 * Chevron-only control that expands or collapses extracted email attachments.
 * Callers place it immediately after the filename and keep the file-type icon in its own slot.
 * Callers must keep filename, checkbox, and overflow actions on separate controls.
 */
export function EmailAttachmentDisclosure({ filename, expanded, onToggle, className, showHoverTooltip = true }: EmailAttachmentDisclosureProps) {
  return (
    <IconButton
      type="button"
      variant="plain"
      color="neutral"
      size="sm"
      // Plain sm is 28px; override to 24px so the chevron matches the file-icon slot (plainIconOuterSizes.sm).
      wrapperClassName="!size-6 shrink-0"
      className={className}
      icon={expanded ? <ChevronDown /> : <ChevronRight />}
      tooltipText={showHoverTooltip ? (expanded ? 'Hide attachments' : 'Show attachments') : undefined}
      tooltipHoverDelayMs={kTooltipHoverDelayMs}
      aria-expanded={expanded}
      aria-label={expanded ? `Hide attachments for ${filename}` : `Show attachments for ${filename}`}
      onClick={(event) => {
        event.stopPropagation()
        event.preventDefault()
        onToggle()
      }}
    />
  )
}
